import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledHeaderBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem 0;
`;

export const StyledLayout = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  padding: 1.5rem 2rem;
`;

export const StyledDetails = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1rem;
  min-height: 20rem;
`;

export const StyledPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20rem;
  border-radius: 1rem;
  background: ${COLORS.GRAY};
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.GREY};
`;
